import { h, Component } from 'preact';
import { track, updateDataLayer } from 'utils/tracking';
import Store from 'store/store';
import * as actions from 'store/actions';
import FilterOption from 'components/pages/showtimes/filterOption.js';
import pure from 'utils/pure';
// import s from 'components/pages/showtimes/filter.sss';

export default @pure class Filter extends Component {
	changed(e) {
		let fid = this.props.filter.id;
		let dlName = 'filter' + fid[0].toUpperCase() + fid.slice(1);
		let dlValue;
		if (e.target.value === 'ALL') {
			Store.emit(actions.RESET_FILTER, this.props.filter.id);
			track({ a: 'clear_filter', l: this.props.filter.id, useCustomPageTrack: true });
			dlValue = 'all';
		} else {
			let selectedIds = [].concat.apply([],
				[].slice.call(e.target.options).filter((o) => (o.selected)).map((o) => (o.value.split(';;;')))
			);

			let options = this.props.filter.options.filter(o => selectedIds.indexOf(o.id + '') !== -1);

			Store.emit(actions.TOGGLE_FILTER, this.props.filter.id, options, this.props.multiple);
			// Getting some 'Can't find variable: track' on iOS for some reason. Add a try/catch for now
			try {
				track({ a: 'add_filter', l: this.props.filter.id, useCustomPageTrack: true });
			} catch (e) {}
			dlValue = selectedIds.join(',');
			if (fid === 'timeOfDay') dlValue = selectedIds.map(val => val.slice(1)).join(',');
			if (fid === 'stDate') dlValue = options.map(opt => opt.ddmmyyyy).join(',');
		}
		if (window.dataLayer && typeof dataLayer.push === 'function') {
			if (fid === 'stDate') dlName = 'filterDate';
			let dlObj = {};
			dlObj[dlName] = dlValue;
			updateDataLayer(dlObj);
		}
	}

	render({ filter, multiple }) {
		// let allActive = filter.current.length === 0 || filter.current.length === filter.options.length;

		let allOption = { id: 'ALL' };
		allOption[filter.displayProp] = filter.displayAllCopyId;

		return (
			<div>
				<select class={this.props.class} multiple={multiple} onChange={this.changed.bind(this)}>
					<FilterOption option={allOption} display={filter.labelAll} />
					{filter.options.map(o => <FilterOption option={o} display={o[filter.displayProp]} selected={filter.current.indexOf(o) !== -1} />)}
				</select>
			</div>
		);
	}
}
